<template>
  <div class="menu-wrap flex flex-col gap-1" style="border: 0">
    <div
      v-permission="'work_space_menu'"
      class="menu-content"
      :class="{
        'active-route': ['workspace', 'workspaceAgentAnalysis'].includes(
          routeName
        )
      }"
      data-testid="workspace-menu-button"
      @click="handleNavigate('workspace')"
    >
      <BotIcon name="ic-workbench" :padding="0" />
      <span class="menu-name">{{
        $t('views.layout.components.MenuList.e4cab9b0e83fe0fed93272c8ae934acd')
      }}</span>
    </div>
    <div
      v-permission="[
        'knowledge_base_menu',
        'data_base_menu',
        'plugin_library_menu'
      ]"
      class="menu-content"
      :class="{
        'active-route': ['resource', 'ideTool'].includes(routeName)
      }"
      space
      tab
      data-testid="resource-menu-button"
      @click="handleNavigate('resource', { space: 'space', tab: 'knowledge' })"
    >
      <BotIcon name="resources" :padding="0" />
      <span class="menu-name">{{
        $t('views.layout.components.MenuList.90101e1b935048a66681055a8ade5ad0')
      }}</span>
    </div>

    <div
      v-permission="'effect_evaluation_menu'"
      class="menu-content"
      :class="{
        'active-route': routeName === 'agentEvaluation'
      }"
      data-testid="agent-evaluation-menu-button"
      @click="handleNavigate('agentEvaluation')"
    >
      <BotIcon name="pen" :padding="0" />
      <span class="menu-name">{{
        $t('views.layout.components.MenuList.7d7f056b33a1b415c74b3ee49e7b9cb4')
      }}</span>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'MenuList',
  props: {
    routeName: {
      type: String,
      default: ''
    }
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const exploreMenuVisible = ref(false);
    const avatar = computed(() => {
      return store.getters.botUserInfo?.avatar;
    });
    const homelandInfo = computed(() => {
      return store.getters.homelandInfo || {};
    });
    const isManager = computed(() => {
      return ['home_owner', 'home_manager'].includes(homelandInfo.value.role);
    });
    const isCompanyUser = computed(() => store.getters.isCompanyUser);
    const handleNavigate = async (route, query = {}) => {
      if (route !== 'workspace') {
        store.commit('clearWorkspaceListState');
      }
      router.push({
        path: `/${route}`,
        query
      });
    };
    return {
      avatar,
      isManager,
      exploreMenuVisible,
      handleNavigate,
      isCompanyUser
    };
  }
});
</script>
<style scoped lang="less">
.menu-item {
  cursor: pointer;
}
.menu-name {
  margin-left: 8px;
  margin-right: 12px;
  color: var(--text-neutral-color-text-primary);
}

.menu-content {
  width: 100%;
  display: flex;
  align-items: center;
  height: 32px;
  margin-bottom: 2px;
  cursor: pointer;
  border-radius: 6px;
  padding: 0 16px;
  &:hover {
    background-color: var(--background-fill-white-color-fill-secondary);
  }
}
.menu-content-disabled {
  cursor: not-allowed;
  color: var(--false-color);
}
.active-route {
  background-color: var(--background-neutral-bg-color-elevated);
  font-weight: 600;
  color: var(--text-primary-color-primary-text);
  .menu-name {
    color: var(--text-primary-color-primary-text);
  }
  &:hover {
    background-color: var(--background-neutral-bg-color-elevated);
  }
}
</style>
